import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import PublisherService from "../../../services/PublisherService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function PublisherModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  publisherTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);

  useEffect(() => {
    if (publisherTarget) {
      setformField([
        { name: ["name"], value: publisherTarget.name },
      ]);
    }
  }, [publisherTarget]);
  const onFinish = (values) => {
    let publisherR = { ...values };
    //console.log("values", values);
    if (publisherTarget) {
        publisherR.id = publisherTarget.id;
        PublisherService.updatePublisher(publisherR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Editorial actualizada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo actualizar la Editorial. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message, 5);
        });
    } else {
        PublisherService.createPublisher(publisherR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Editorial registrada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo registar la Editorial. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message);
        });
    }
  };

  return (
    <Modal
      title="Registrar Editorial"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre de la Editorial"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre de la Editorial.",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      {/*   <Form.Item
          name="shortName"
          label="Siglas"
          rules={[
            {
              required: true,
              message: "Por favor ingresa las siglas de la carrera",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item> */}
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
